<template>
  <div id="app" class="pt-14">
    <LoginOverlay class="fixed z-20"
      v-if="showLoginOverlay"
      @closePrompt="closeLoginPrompt"
    />
    <NavBar />
    <transition name="fade">
      <router-view class="max-h-[calc(100vh-3.5rem)] min-h-[calc(100vh-3.5rem)] overflow-y-auto">
      </router-view>
    </transition>
  </div>
</template>

<script>
import { default as auth0User } from './services/auth0/user.js'
import user from './services/user/user.js'
import events from './services/events.js'

import NavBar from './components/NavBar.vue'
import LoginOverlay from './components/auth0/LoginOverlay.vue'


export default {
  components: {
    NavBar,
    LoginOverlay,
  },
  props: {
    siteHomeUrl: String,
    apiUrl: String,
    nonce: String,
  },
  data() {
    return {
      transitionName: 'slide-left',
      showLoginOverlay: false,
    }
  },
  eventCallbackIds: {},
  methods: {
    updateUser() {
      user.get().then(_user => {
        console.log(_user)
      })
    },
    closeLoginPrompt() {
      this.showLoginOverlay = false
    }
  },
  // then, in the parent component,
  // watch the `$route` to determine the transition to use
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    },
  },
  created() {
    document.title = 'CST Portal'
    this.$options.eventCallbackIds.showLoginOverlay = events.register(
      'showLoginOverlay',
      () => {
        this.showLoginOverlay = true
      }
    )

    auth0User.get().then(async (auth0Client) => {
      const isAuthenticated = await auth0Client.isAuthenticated()
      this.showLoginOverlay = !isAuthenticated

      this.updateUser()
    })
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove(
      'showLoginOverlay',
      this.$options.eventCallbackIds.showLoginOverlay
    )
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.logo {
  width: 3%;
  height: auto;
}

.router-link-active {
  color: red;
}
/* it applys to all row classes inside a form that's inside a container class */
/* the parent of the form has to ba a container class */
.container form .row {
  text-align: left;
  align-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
